import "./Tooltip.scss";

export { RegularTooltip as Tooltip } from "@sportal/cdk";
